import React from 'react';
import { Box, Paper, Text } from '../../styles';
import { SurveyItem, UserVote } from 'common/apiService/types/publicApiTypes';
import styled from '@emotion/styled';
import VideoThumb from './VideoThumb';
import QuantityInput from './QuantityInput';

interface VoteCardProps {
  item: SurveyItem;
  onChange: (vote: UserVote) => void;
  value?: number;
  max: number;
  disabled?: boolean;
  limited?: string;
  userParticipatedPoints?: boolean;
}

const Container = styled(Paper)(({ theme }) => ({
  textAlign: 'center',
  borderRadius: theme.radius.medium,
  padding: 0,
}));

export default function VoteCard({ value, onChange, item, max, disabled, limited, userParticipatedPoints }: VoteCardProps) {
  const handleChange = (value: number) => {
    onChange?.({
      survey_item_id: item.id,
      vote_points: value,
    });
  };

  return (
    <Container key={item?.id}>
      <VideoThumb {...item} />
      <Box p={2}>
        <Text variant="body2">
          {item?.title}
        </Text>
        <QuantityInput
          value={value || 0}
          onChange={handleChange}
          max={max}
          limited={value === max ? 'vote.item_vote_restriction' : limited}
          disabled={disabled}
          hasParticipate={userParticipatedPoints}
        />
      </Box>
    </Container>
  );
}
